<template>
  <header id="head_top" class="head_top">
    <section class="head_detail">
      <span>{{ headTitle }}</span>
      <div class="ico_back" @click="$router.go(-1)"></div>
    </section>
  </header>
</template>
<script>
export default {
  props: ["headTitle"]
};
</script>
<style>
.head_top {
  background-image: linear-gradient(
    46deg,
    #e83e44 0%,
    #e94043 3%,
    #1d2088 100%
  );
  background-image: -webkit-linear-gradient(
    46deg,
    #e83e44 0%,
    #e94043 3%,
    #1d2088 100%
  );
  height: 36px;
  line-height: 36px;
  text-align: center;
  font-size: 16px;
  color: #ffffff;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 12;
}
.head_detail {
  height: 100%;
  position: relative;
}
.ico_back {
  background: url(data:image/svg+xml;base64,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)
    0 0 no-repeat;
  background-size: 100% auto;
  -webkit-background-size: 100% auto;
  width: 25px;
  height: 25px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  left: 14px;
}
</style>
